// extracted by mini-css-extract-plugin
module.exports = {"container":"Labels_container__NpQ93","label":"Labels_label__BC5_N"};